var map = {
	"./bio-based-waste-stream-biocomposite/block.png": [
		2648,
		2648
	],
	"./biochar-based-bioplastic/block.png": [
		3549,
		3549
	],
	"./biodegradable-and-bio-based-materials/block.png": [
		313,
		313
	],
	"./biodegradable-biopolymer/block.png": [
		2834,
		2834
	],
	"./cellulose-acoustic-panel/block.png": [
		9593,
		9593
	],
	"./compostable-foam/block.png": [
		5527,
		5527
	],
	"./cork-based-material/block.png": [
		6633,
		6633
	],
	"./fish-scale-board/block.png": [
		322,
		322
	],
	"./kraft-lignin/block.png": [
		22,
		22
	],
	"./lignin-nanoparticles/block.png": [
		5797,
		5797
	],
	"./microalgae-derived-zero-carbon-bio-cement/block.png": [
		1707,
		1707
	],
	"./mycelium-based-acoustic-panels/block.png": [
		821,
		821
	],
	"./mycelium-based-building-material/block.png": [
		7032,
		7032
	],
	"./osl/block.png": [
		5910,
		5910
	],
	"./plastic-free-leather/block.png": [
		8021,
		8021
	],
	"./polycrystalline-silicon/block.png": [
		2846,
		2846
	],
	"./recycled-paper-boards/block.png": [
		1990,
		1990
	],
	"./recycled-paper-composite/block.png": [
		8471,
		852
	],
	"./recycled-paper-panel/block.png": [
		119,
		119
	],
	"./seaweed-paper/block.png": [
		7043,
		7043
	],
	"./sodium-lignosulfonate/block.png": [
		8594,
		8594
	],
	"./starch-based-composite/block.png": [
		5623,
		5623
	],
	"./waste-leaf-paper/block.png": [
		8708,
		8708
	],
	"./water-resistant-lignin-coating/block.png": [
		1401,
		1401
	],
	"./wood-based-plastic-alternative/block.png": [
		154,
		154
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(() => {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return __webpack_require__.e(ids[1]).then(() => {
		return __webpack_require__.t(id, 1 | 16);
	});
}
webpackAsyncContext.keys = () => (Object.keys(map));
webpackAsyncContext.id = 909;
module.exports = webpackAsyncContext;